import { SVGProps } from '@components/Icon/types';

export const Import = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 13.3C3.6134 13.3 3.3 13.6134 3.3 14V19.5C3.3 20.4389 4.0611 21.2 5 21.2H19C19.9389 21.2 20.7 20.4389 20.7 19.5V14C20.7 13.6134 20.3866 13.3 20 13.3C19.6134 13.3 19.3 13.6134 19.3 14V19.5C19.3 19.6657 19.1657 19.8 19 19.8H5C4.8343 19.8 4.7 19.6657 4.7 19.5V14C4.7 13.6134 4.3866 13.3 4 13.3Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2662 3.3C12.6538 3.3 12.9662 3.6134 12.9662 4V14.4157L15.8502 11.997C16.1464 11.7485 16.5879 11.7873 16.8363 12.0835C17.0848 12.3797 17.046 12.8212 16.7498 13.0697L12.7257 16.4447C12.6383 16.5208 12.5317 16.5756 12.4143 16.6009C12.2065 16.6459 11.9826 16.5952 11.8115 16.4493L7.8457 13.0658C7.5516 12.8149 7.5165 12.3731 7.7675 12.079C8.0184 11.7849 8.4602 11.7499 8.7543 12.0008L11.5662 14.3997V4C11.5662 3.6134 11.8786 3.3 12.2662 3.3Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'import';
